interface IParameterObject {
    [key: string]: string;
}

export function getUrlParameters(): IParameterObject | undefined {
    if (!global.window) {
        return;
    }

    const params: IParameterObject = {};

    if (document.location && document.location.toString().indexOf("?") !== -1) {
        const query = (document as any).location
            .toString()
            .replace(/^.*?\?/, "")
            .replace(/#.*$/, "")
            .split("&");

        for (let i = 0, l = query.length; i < l; i++) {
            const aux = decodeURIComponent(query[i]).split("=");
            params[aux[0]] = aux[1];
        }
    }

    if (Object.keys(params).length === 0) {
        return;
    }

    return params;
}

export function getUrlParameterByName(name: string): string | undefined {
    const params = getUrlParameters();
    return params && params[name];
}

export function updateUrlParameters(parameters: IParameterObject, replace = false): void {
    const parameterKeys = Object.keys(parameters);

    if (parameterKeys.length === 0 || !global.window) {
        return;
    }

    const parameterString = parameterKeys
        .map(p => encodeURIComponent(p) + "=" + encodeURIComponent(parameters[p]))
        .join("&");

    replace
        ? window.history.replaceState({}, "", `?${parameterString}`)
        : window.history.pushState({}, "", `?${parameterString}`);
}

export default {
    getUrlParameters,
    getUrlParameterByName,
    updateUrlParameters
};
